import React, { Component } from "react";
import PropTypes from "prop-types";
import Script from "react-load-script";
import { get } from "lodash";
import WebConfig from "middlewares/WebConfig";

class SearchGooglePlaces extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.value !== prevProps.value) {
      this.setState({ value: this.props.value });
    }
  };

  handleScriptLoad = () => {
    // Initialize Google Autocomplete
    /*global google*/
    // autocomplete widget handles session tokens
    // https://stackoverflow.com/questions/51728344/google-places-autocomplete-widget-is-generating-a-new-session-key-per-every-requ
    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.props.id), {
      fields: [
        "address_components.types",
        "address_components.short_name",
        "geometry.location",
        "place_id",
        "formatted_address",
      ],
      componentRestrictions: { country: "us" },
      language: "en",
    });
    // Fire Event when a suggested name is selected
    this.autocomplete.addListener("place_changed", this.handlePlaceSelect);
  };

  handlePlaceSelect = () => {
    let place = this.autocomplete.getPlace();
    if (!place.place_id) {
      return;
    }
    let { address_components, geometry } = place;
    let address = {
      streetNumber:
        get(
          address_components.find((c) => c.types.includes("street_number")),
          "short_name",
        ) || "",
      route:
        get(
          address_components.find((c) => c.types.includes("route")),
          "short_name",
        ) || "",
      get streetAddress() {
        return `${this.streetNumber || ""}${this.route ? " " + this.route : ""}`;
      },
      city:
        get(
          address_components.find((c) => c.types.includes("locality")),
          "short_name",
        ) || "",
      state:
        get(
          address_components.find((c) => c.types.includes("administrative_area_level_1")),
          "short_name",
        ) || "",
      zip:
        get(
          address_components.find((c) => c.types.includes("postal_code")),
          "short_name",
        ) || "",
      latitude: geometry.location.lat().toFixed(5),
      longitude: geometry.location.lng().toFixed(5),
      formatted: place.formatted_address,
    };
    let result = "";
    if (address.streetNumber == "") {
      let x = document.getElementById(this.props.id).value;
      address.streetNumber = x.substr(0, x.indexOf(" "));
      address.formatted = x;
      address.longitude = "";
      address.latitude = "";
    }
    result = this.props.streetAddressOnly ? address.streetAddress : address.formatted;

    this.setState({ value: result });
    this.props.onChange(address);
  };

  render() {
    const { value } = this.state;
    const { id } = this.props;
    return (
      <div className="search-google-places">
        <Script
          url={`https://maps.googleapis.com/maps/api/js?key=${WebConfig.googleMapsApiKey}&libraries=places`}
          onLoad={this.handleScriptLoad}
        />
        <input
          id={id}
          value={value || ""}
          autoComplete="off"
          onChange={(e) => {
            this.setState({ value: e.target.value });
          }}
        />
      </div>
    );
  }
}

SearchGooglePlaces.propTypes = {
  /* Callback that will be called with an address object
    {
      streetNumber,
      route,
      streetAddress,
      city,
      state,
      zip,
      latitude,
      longitude,
      formatted,
    } */
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  streetAddressOnly: PropTypes.bool, // Show only the street address in the field. Will show complete address if not set to true
};

export default SearchGooglePlaces;
